import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryPlumbingIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-plumbing"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      d="M14.4789 16.7025C14.6122 16.7036 14.7216 16.8196 14.7099 16.9524C14.4638 19.7559 12.1442 21.9525 9.32039 21.9525C6.33706 21.9525 3.91655 19.5009 3.90918 16.4718V11.5712C3.90918 11.4339 4.02049 11.3225 4.15787 11.3225H7.06373C7.201 11.3225 7.31241 11.4339 7.31241 11.5712V16.4685C7.31241 17.5954 8.21211 18.509 9.32201 18.509C10.297 18.509 11.1097 17.804 11.2929 16.8689C11.3144 16.7593 11.4033 16.677 11.515 16.6779L14.4789 16.7025Z"
    />
    <path
      className="fill-brand-primary"
      d="M4.1511 9.58479H7.07039C7.20413 9.58479 7.31241 9.47651 7.31241 9.34287V3.6562C7.31241 3.52247 7.20413 3.41418 7.07039 3.41418H4.1511C4.01756 3.41418 3.90918 3.52247 3.90918 3.6562V9.34287C3.90918 9.47651 4.01756 9.58479 4.1511 9.58479Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M15.0511 15.3007H11.0152C10.8755 15.3008 10.7416 15.3566 10.6423 15.4561C10.5435 15.5553 10.4882 15.6905 10.489 15.8315C10.4911 16.125 10.726 16.3621 11.0152 16.3623H15.0511C15.1899 16.3636 15.3234 16.3075 15.4207 16.2067C15.5703 16.055 15.615 15.8266 15.534 15.6282C15.4531 15.4299 15.2625 15.3006 15.0511 15.3007Z"
    />
    <path
      className="fill-brand-primary"
      d="M14.4861 14.9284C14.6403 14.9284 14.7591 14.8096 14.7831 14.6573C14.9372 13.6831 15.7686 12.9436 16.7663 12.9439H19.5897C19.7346 12.9439 19.8522 12.8263 19.8522 12.6813V9.75083C19.8522 9.60588 19.7346 9.4884 19.5897 9.4884H16.7663C13.9043 9.49143 11.5584 11.7487 11.3675 14.6124C11.356 14.7833 11.4992 14.9284 11.6703 14.9284H14.4861Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M7.99837 10.8288C8.09645 10.7305 8.1516 10.5966 8.1516 10.4568C8.151 10.1619 7.91585 9.92315 7.62544 9.92255H3.58969C3.45201 9.92275 3.32019 9.97881 3.22342 10.0781C3.12544 10.1791 3.07039 10.3151 3.07019 10.4568C3.07049 10.748 3.30292 10.984 3.58969 10.9844H7.62544C7.76494 10.9842 7.89898 10.9283 7.99837 10.8288Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M3.58958 2.01465C3.3016 2.01626 3.06827 2.25293 3.06665 2.54525C3.06736 2.83828 3.30099 3.07566 3.58958 3.07626H7.62867C7.91726 3.07626 8.1517 2.83859 8.1517 2.54525C8.1517 2.25222 7.91726 2.01465 7.62867 2.01465H3.58958Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M20.1616 8.93159V13.033C20.1601 13.2235 20.2595 13.4004 20.4218 13.496C20.5843 13.5919 20.7847 13.5919 20.947 13.496C21.1094 13.4004 21.2087 13.2235 21.2073 13.033V8.93159C21.2055 8.63916 20.9724 8.4027 20.6845 8.40088C20.396 8.40138 20.1622 8.63876 20.1616 8.93159Z"
    />
  </Svg>
));

CategoryPlumbingIcon.displayName = 'CategoryPlumbingIcon';
